import { GraphQL } from "@rpi/openapi-api";
import { resolveStatusName } from "./unrecognizedStatus";

// The one place a payment status is named. Every designed value matches the Order Cancellation flow in
// Figma TCASWROepLNCI9wdCZLsJF; PAYMENT_PENDING is not in that design and is named here by convention.
export const PAYMENT_STATUS_NAMES: Record<GraphQL.PaymentStatus, string> = {
  [GraphQL.PaymentStatus.ExternallyPaid]: "Externally Paid",
  [GraphQL.PaymentStatus.Paid]: "Paid",
  [GraphQL.PaymentStatus.Unpaid]: "Unpaid",
  [GraphQL.PaymentStatus.NoPaymentStaffOrder]: "No Payment - Staff Order",
  [GraphQL.PaymentStatus.PaymentPending]: "Payment Pending",
  [GraphQL.PaymentStatus.Voided]: "Voided",
  [GraphQL.PaymentStatus.ProcessingRefund]: "Processing Refund",
  [GraphQL.PaymentStatus.RefundedFull]: "Refunded - Full",
  [GraphQL.PaymentStatus.RefundedShipping]: "Refunded - Shipping",
  [GraphQL.PaymentStatus.RefundedPartial]: "Refunded - Partial",
};

export function paymentStatusName(status: GraphQL.PaymentStatus): string {
  return resolveStatusName(PAYMENT_STATUS_NAMES, "PaymentStatus", status);
}

// The payment statuses the API can filter on. Stated rather than derived from the enum: filtering on a value
// the deployed backend does not know is rejected as a bad request, which fails the whole order query, so a
// newly added status joins this list only once that backend is live.
export const FILTERABLE_PAYMENT_STATUSES: ReadonlyArray<GraphQL.PaymentStatus> = [
  GraphQL.PaymentStatus.Paid,
  GraphQL.PaymentStatus.Unpaid,
  GraphQL.PaymentStatus.PaymentPending,
  GraphQL.PaymentStatus.ExternallyPaid,
  GraphQL.PaymentStatus.NoPaymentStaffOrder,
  GraphQL.PaymentStatus.Voided,
  GraphQL.PaymentStatus.ProcessingRefund,
  GraphQL.PaymentStatus.RefundedFull,
  GraphQL.PaymentStatus.RefundedShipping,
  GraphQL.PaymentStatus.RefundedPartial,
];
